// Node Modules
import { nanoid } from 'nanoid';

// Themes
import theme from '@/themes/index';

const List = ({
  content: {
    title,
    highlights, 
  }, 
}) => {
  return (
    <>
      <div className='institution-details'>
        <h6>{title}</h6>
        <ul>
          {highlights.map(highlight => (
            <li key={nanoid()}>{highlight.text}</li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        div.institution-details h6 {
          font-family: ${theme.fontFamilies.montserratBold};
          text-decoration: underline;
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }

        div.institution-details ul {
          padding-inline-start: 1.5rem;
          font-family: ${theme.fontFamilies.montserrat};
          margin-block-start: 2em;
          line-height: 1.5rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          div.institution-details ul {
            column-count: 2;
            font-size: 1.5rem;
            line-height: 2.25rem;
          }
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.institution-details ul {
            column-gap: 9.0625rem;
          }
        }
      `}</style>
    </>
  );
};

export default List;
